import {Box, Button, TextField, Tooltip, Typography,} from "@mui/material";
import {Fragment, useEffect, useState} from "react";
import EditIcon from "@mui/icons-material/Edit";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {DemoContainer, DemoItem} from "@mui/x-date-pickers/internals/demo";
import DeleteIcon from "@mui/icons-material/Delete";
import AssessmentIcon from "@mui/icons-material/Assessment";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {
    deleteKeywordCluster,
    findAllClusters,
    updateKeywordCluster,
} from "../../../../api/specialization/KeywordSpecializationAPI";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {errorNoti} from "../../../../util/SnackbarMessage";
import {useSnackbar} from "notistack";
import dayjs from "dayjs";
import {DataGrid} from "@mui/x-data-grid";
import TrendzModal from "../../../../components/TrendzModal";

export function KeywordClusterListV2() {
    const [keywordClusters, setKeywordClusters] = useState([]);
    const [chosenCluster, setChosenCluster] = useState({
        id: 0,
        name: "",
        relatedKeywords: [],
    });
    const {t} = useTranslation(["common", "keyword", "error"]);
    const [clusterFormName, setClusterFormName] = useState(chosenCluster.name);
    const [relatedKeywordsForm, setRelatedKeywordsForm] = useState(
        chosenCluster.relatedKeywords.join(",")
    );
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openReportDialog, setOpenReportDialog] = useState(false);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const {enqueueSnackbar} = useSnackbar();

    useEffect(() => {
        findAllClusters()
            .then((res) => {
                setKeywordClusters(res);
            })
            .catch((err) => {
                var noti = errorNoti(err);
                enqueueSnackbar(t("error:" + noti.message), noti.option);
            });
    }, []);

    var handleDelete = (cluster) => {
        deleteKeywordCluster(cluster["id"]).then(() => {
            window.location.reload();
        });
        setOpenDeleteDialog(false);
    };

    var handleEdit = () => {
        var relatedKeywords = relatedKeywordsForm.split(",");
        relatedKeywords = relatedKeywords.map((keyword) => {
            return keyword.trim();
        });
        if (chosenCluster.id !== 0) {
            updateKeywordCluster(
                chosenCluster.id,
                clusterFormName,
                relatedKeywords
            ).then(() => {
                window.location.reload();
            });
        }

        setOpenEditDialog(false);
    };

    var handleDeleteDialogOpen = (cluster) => {
        setChosenCluster(cluster);
        setOpenDeleteDialog(true);
    };

    var handleReportDialogOpen = (cluster) => {
        setChosenCluster(cluster);
        setOpenReportDialog(true);
    };

    var handleEditDialogOpen = (cluster) => {
        setChosenCluster(cluster);
        setClusterFormName(cluster.name);
        setRelatedKeywordsForm(cluster.relatedKeywords.join(", "));
        setOpenEditDialog(true);
    };

    const columns = [
        {
            field: "name",
            headerName: t("keyword:cluster_name"),
            renderCell: (row) => {
                return <Box>
                    <Link to={"/specialization/cluster/" + row.row["id"]}>
                        {row.value}
                    </Link>
                </Box>
            },
            width: 180,
        },
        {
            field: "related_keywords",
            headerName: t("keyword:related_keywords"),
            renderCell: (row) => {
                return <Box>
                    {row.row["relatedKeywords"].join(", ")}
                </Box>
            },
            width: 320,
        },
        {
            headerName: t("common:actions"),
            width: 380,
            renderCell: (row) => {
                let cluster = row.row;
                return <Box display={"flex"}>
                    <Tooltip title={t("keyword:edit_cluster")}>
                        <Button
                            variant="contained"
                            color="info"
                            style={{marginRight: "10px"}}
                            onClick={() => handleEditDialogOpen(cluster)}
                        >
                            <EditIcon/>
                        </Button>
                    </Tooltip>
                    <Tooltip title={t("keyword:request_cluster_report")}>
                        <Button
                            variant="contained"
                            color="success"
                            style={{marginRight: "10px"}}
                            onClick={() => handleReportDialogOpen(cluster)}
                        >
                            <AssessmentIcon/>
                        </Button>
                    </Tooltip>
                    <Tooltip title={t("keyword:delete_cluster")}>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={() => handleDeleteDialogOpen(cluster)}
                        >
                            <DeleteIcon/>
                        </Button>
                    </Tooltip>
                </Box>
            },
        },
    ];
    return (
        <Fragment>
            <DataGrid
                autoHeight={true}
                rows={keywordClusters}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10, 20, 50]}
                disableSelectionOnClick
            />
            <TrendzModal
                open={openEditDialog}
                onClose={() => setOpenEditDialog(false)}
                onOk={handleEdit}
                textOk={t("common:save")}
                title={t("keyword:edit_cluster")}
                maxWidthPaper="400px"
            >
                <TextField
                    variant="standard"
                    label={t("common:name")}
                    placeholder={chosenCluster.name.toString()}
                    fullWidth
                    required
                    defaultValue={chosenCluster.name.toString()}
                    value={clusterFormName}
                    onChange={(e) => {
                        setClusterFormName(e.target.value);
                    }}
                />
                <Box sx={{height: "24px"}}/>
                <TextField
                    variant="standard"
                    label={t("keyword:related_keywords")}
                    placeholder={""}
                    defaultValue={chosenCluster.relatedKeywords.join(",")}
                    fullWidth
                    required
                    value={relatedKeywordsForm}
                    onChange={(e) => {
                        setRelatedKeywordsForm(e.target.value);
                    }}
                />
            </TrendzModal>
            <TrendzModal
                open={openReportDialog}
                onClose={() => setOpenReportDialog(false)}
                onOk={() => {
                }}
                textOk={t("common:save")}
                title={t("keyword:request_cluster_report") + " '" + chosenCluster.name + "'"}
                maxWidthPaper="480px"
            >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker"]}>
                        <DemoItem label={t("common:from_date")}>
                            <DatePicker defaultValue={dayjs()}></DatePicker>
                        </DemoItem>
                        <DemoItem label={t("common:to_date")}>
                            <DatePicker defaultValue={dayjs()}></DatePicker>
                        </DemoItem>
                    </DemoContainer>
                </LocalizationProvider>
                <TextField
                    label={t("keyword:additional_questions")}
                    placeholder={t("keyword:you_can_ask_for_information")}
                    fullWidth
                    required
                    variant="standard"
                    defaultValue={chosenCluster.name.toString()}
                    value={clusterFormName}
                    onChange={(e) => {
                        setClusterFormName(e.target.value);
                    }}
                    sx={{marginTop: "16px"}}
                ></TextField>
                <Typography sx={{marginTop: "16px", color: "gray"}}>
                    {"* " + t("keyword:you_can_only_request_upto") + " " + "15 " + t("keyword:reports_per_day")}
                </Typography>
            </TrendzModal>
            <TrendzModal
                open={openDeleteDialog}
                onClose={() => setOpenDeleteDialog(false)}
                onOk={() => handleDelete(chosenCluster)}
                textOk={t("common:delete")}
                // title={t("keyword:delete_cluster")}
                maxWidthPaper="360px"
            >
                {t("keyword:confirm_delete_cluster")} '{chosenCluster.name}'?
            </TrendzModal>
        </Fragment>

    );
}
